import { selectStandardProps } from "@/utils/componentUtils";
import { Form, Select } from "antd";
import { FormItemProps } from "antd/lib/form";
import { SelectProps } from "antd/lib/select";
import { useEnumeration } from "../../../../common/api/queries";
import { EnumerationType } from "../../enums";

interface Props {
  formItemProps: FormItemProps;
  selectProps?: SelectProps<string>;
}

const VehicleColorSelect = ({ formItemProps, selectProps }: Props) => {
  const vehicleColorsEnums = useEnumeration(EnumerationType.VEHICLE_COLORS);

  return (
    <Form.Item {...formItemProps}>
      <Select
        {...selectStandardProps}
        {...selectProps}
        options={vehicleColorsEnums.map((color) => ({ value: color.id, label: color.value }))}
      />
    </Form.Item>
  );
};

export default VehicleColorSelect;
